import React from 'react';
import { useTranslation } from '../i18n/LocaleContext';

const PartnerScroll = () => {
  const { t } = useTranslation();
  
  const partners = [
    { name: 'Amazon', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg' },
    { name: 'eBay', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1b/EBay_logo.svg' },
    { name: 'Shopify', logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0e/Shopify_logo_2018.svg' },
    { name: 'Apple', logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg' },
    { name: 'Nvidia', logo: 'https://upload.wikimedia.org/wikipedia/sco/2/21/Nvidia_logo.svg' },
    { name: 'Walmart', logo: 'https://upload.wikimedia.org/wikipedia/commons/c/ca/Walmart_logo.svg' },
    { name: 'Target', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Target_logo.svg' },
    { name: 'Best Buy', logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f5/Best_Buy_Logo.svg' },
    { name: 'Alibaba', logo: 'https://upload.wikimedia.org/wikipedia/commons/8/80/Alibaba-vector-logo.svg' },
    { name: 'Etsy', logo: 'https://upload.wikimedia.org/wikipedia/commons/8/89/Etsy_logo.svg' }
  ];

  return (
    <div className="bg-white border-y border-black/5 py-3 overflow-hidden">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-ink-muted text-center mb-2">{t('ourPartners')}</p>
      <div className="relative flex overflow-hidden">
        <div className="flex animate-scroll">
          {[...partners, ...partners].map((partner, index) => (
            <div
              key={index}
              className="flex items-center justify-center mx-4 flex-shrink-0"
            >
              <div className="w-20 h-12 bg-white rounded-lg flex items-center justify-center p-2">
                <img 
                  src={partner.logo} 
                  alt={partner.name}
                  className="max-w-full max-h-full object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <span className="text-xs font-semibold text-gray-700" style={{ display: 'none' }}>
                  {partner.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
      `}} />
    </div>
  );
};

export default PartnerScroll;
